import { memo } from "react";

export const ChevronIcon = memo(() => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.07422 5.25562L2.25268 4.07715L7.99658 9.82099L13.7404 4.07715L14.9188 5.25561L7.99659 12.1779L1.07422 5.25562Z"
      fill="currentColor"
    />
  </svg>
));
